<div class="form-container" style="
    display: flex; 
    justify-content: center; 
    align-items: center; 
    height: 20vh; 
    width: 50%;  
    margin-top: 6px;
    box-sizing: border-box;">
  <form [formGroup]="form" style="width: 100%; max-width: 400px; box-sizing: border-box; text-align: center;">
    <div style="height: 50px;">
      <mat-form-field appearance="outline" style="width: 100%;">
        <mat-label>Dataset Name</mat-label>
        <input matInput type="text" placeholder="Dataset Name" formControlName="datasetName" maxlength="100" required>
        <mat-error *ngFor="let validation of validation_messages.datasetName">
          <span *ngIf="datasetName?.hasError(validation.type) && (datasetName?.dirty || datasetName?.touched)">
            {{ validation.message }}
          </span>
        </mat-error>
      </mat-form-field>
    </div>

    <div style="padding-top: 20px;">
      <button id="copydataset"
        class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
        [style.background-color]="buttonColor" title="Copy Dataset" (click)="onCopy()" [disabled]="form.invalid"
        style="margin-right: 10px;">
        Copy Dataset
      </button>
      <button id="cancel"
        class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
        [style.background-color]="buttonColor" title="Cancel" (click)="onCancel()">
        Cancel
      </button>
    </div>
  </form>
</div>